import { getBrands } from '@/redux/actions/brands'
import { IRootState } from '@/redux/types'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

function useIntialState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { brands } = useSelector((state: IRootState) => state.brand)

  useEffect(() => {
    if (brands.length === 0) dispatch(getBrands())
  }, [])

  const adminContentFilter = [
    {
      data: [
        { id: 0, name: 'Activo' },
        { id: 1, name: 'Inactivo' }
      ],
      code: 'status',
      column: 'status'
    },
    {
      data: [
        { id: 0, name: t('close') },
        { id: 1, name: 'VIP' }
      ],
      code: 'visibility',
      column: 'visibility'
    }
  ]

  return { adminContentFilter }
}

export default useIntialState
